<template>
    <div>
        <p
            v-if="paragraphType === 'string'"
            class="text"
            v-html="$t(content)"
        ></p>
        <p
            v-else
            class="text"
            v-for="(paragraph, i) in content"
            :key="i"
            v-html="$t(paragraph)"
        ></p>
    </div>
</template>

<script>
export default {
    name: 'ParagraphText',
    props: {
        content: [String, Array],
    },
    computed: {
        paragraphType() {
            return typeof this.content;
        },
    },
};
</script>

<style lang="scss" scoped>
.text {
    font-size: 16px;
    line-height: 140%;
    &:not(:last-of-type) {
        margin-bottom: 10px;
    }
}
</style>
